import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Page, UcepDataImportDto} from "../../../../../generated-model/model";
import {IgnoreNullHttpParams} from "../../../../shared/commons/Ignore-null-http-params";

@Injectable({
  providedIn: 'root'
})
export class UcepService {

  http = inject(HttpClient)
  constructor() { }

  save(request: UcepDataImportDto[]) {
    return this.http.post('api/ucep-group-register/save',request)
  }

  search(param: IgnoreNullHttpParams) {
    return this.http.get<Page<UcepDataImportDto>>('api/ucep-group-register/search', {params: param.toHttpParam()});
  }

  reProcess(pid: string) {
    return this.http.post<void>('api/ucep-group-register/re-process', null, {params: {pid}});
  }

}
